import { cohesionEvents } from "shared/components/Cohesion/constants/events";
import { track } from "shared/components/Cohesion/tagular";

export const makeElementEvent = (eventName, eventProperties) => {
  const properties = { ...eventProperties };
  if (eventProperties.webElement) {
    properties.webElement = {
      ...eventProperties.webElement,
    };
  }

  track({ eventName, properties });
};

export const elementClicked = (data) => {
  makeElementEvent(cohesionEvents.elementClicked, data);
};

export const elementSwiped = (data) => {
  makeElementEvent(cohesionEvents.elementSwiped, data);
};

export const elementViewed = (data) => {
  makeElementEvent(cohesionEvents.elementViewed, data);
};
